import React from "react";
import SEO from "../components/SEO";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import HexaPiClub from "../components/HexaPiClub";
import Portfolio from "../components/Portfolio";
import Gallery from "../components/Gallery";
import Contact from "../components/Contact";

const HomePage = () => {
  return (
    <>
      <SEO
        title="HexaPi Tech - Innovative Electronic & Software Solutions"
        description="HexaPi Tech develops innovative and customized electronic and software solutions in Lebanon. From prototyping to deployment, we offer AI, robotics, web development, and automation services."
        url="https://hexapi.tech"
      />
      <Hero />
      <About />
      <Services />
      <HexaPiClub />
      <Portfolio />
      <Gallery />
      <Contact />
    </>
  );
};

export default HomePage;
